



























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HelloWorld extends Vue {
  private picker: boolean = false;
  @Prop() private color!: string;
  @Prop() private label!: string;

  private swatches: string[][] = [
    ['#000000', '#FFFFFF', '#F0F0F0'],
    ['#FF0000', '#AA0000', '#550000'],
    ['#FFFF00', '#AAAA00', '#555500'],
    ['#00FF00', '#00AA00', '#005500'],
    ['#00FFFF', '#00AAAA', '#005555'],
  ];

  private handleColorChange(color: string) {
    this.$emit('colorChange', color);
  }
}
